export type ControlDataImageDeletion = {
  message: string;
};
